import type * as React from "react";
import { StickToBottom } from "use-stick-to-bottom";
import { cn } from "@/lib/utils";

function ChatContainerRoot({
  children,
  className,
  ...props
}: React.ComponentProps<"div">) {
  return (
    <StickToBottom
      className={cn("flex overflow-y-auto", className)}
      data-slot="chat-container-root"
      initial="instant"
      resize="smooth"
      role="log"
      {...props}
    >
      {children}
    </StickToBottom>
  );
}

function ChatContainerContent({
  children,
  className,
  ...props
}: React.ComponentProps<"div">) {
  return (
    <StickToBottom.Content
      className={cn("flex w-full flex-col", className)}
      data-slot="chat-container-content"
      {...props}
    >
      {children}
    </StickToBottom.Content>
  );
}

function ChatContainerScrollAnchor({
  className,
  ...props
}: React.ComponentProps<"div">) {
  return (
    <div
      aria-hidden="true"
      className={cn("h-px w-full shrink-0 scroll-mt-4", className)}
      data-slot="chat-container-scroll-anchor"
      {...props}
    />
  );
}

export { ChatContainerContent, ChatContainerRoot, ChatContainerScrollAnchor };
